/* Липкая шапка (APP-SPEC §1.8, BotCore.sticky): у прилипшей .bc-sticky — класс sc (фон и растворение под ней, стили bot-core.css).
   Класс ставит один слушатель прокрутки на документ (фаза захвата, не чаще раза в кадр). sync(корень) — после перерисовки без прокрутки. */
const SEL = '.bc-sticky';

type Scroller = HTMLElement & { _bcSr?: Element };

/** Ближайший прокручиваемый предок; нет — корень документа */
export function stickyRoot(h: Element): Element {
  let p = h.parentElement;
  while (p && p !== document.body && p !== document.documentElement) {
    const v = getComputedStyle(p).overflowY;
    if (v === 'auto' || v === 'scroll' || v === 'overlay') return p;
    p = p.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

/** Шапка стоит у края прокрутки, а прокрутка ушла вниз больше 2 px */
export function stickyOn(h: Element | null): boolean {
  if (!h || !h.isConnected) return false;
  const hs = h as Scroller;
  let r = hs._bcSr;
  if (!r || !r.isConnected || !r.contains(h)) r = hs._bcSr = stickyRoot(h);
  if (!r || r.scrollTop <= 2) return false;
  const top = parseFloat(getComputedStyle(h).top) || 0;
  const doc = r === document.scrollingElement || r === document.documentElement;
  const rt = doc ? 0 : r.getBoundingClientRect().top + r.clientTop + (parseFloat(getComputedStyle(r).paddingTop) || 0);
  return h.getBoundingClientRect().top - rt <= top + 1;
}

/** Класс sc у шапок внутри root — только там, где сменился */
export function stickySync(root?: Element | null): void {
  const r = root || document;
  r.querySelectorAll(SEL).forEach(h => {
    const on = stickyOn(h);
    if (h.classList.contains('sc') !== on) h.classList.toggle('sc', on);
  });
}

let installed = false;
/** Общий слушатель прокрутки; ставится один раз (прототип ставит свой такой же, оба дают один результат) */
export function installSticky(): void {
  if (installed) return;
  installed = true;
  const q = new Set<Element>();
  let f = 0;
  document.addEventListener(
    'scroll',
    e => {
      const t = e.target as Element | null;
      if (!t || !('querySelector' in t) || !t.querySelector(SEL)) return;
      q.add(t);
      if (f) return;
      f = requestAnimationFrame(() => {
        f = 0;
        const L = [...q];
        q.clear();
        L.forEach(stickySync);
      });
    },
    true,
  );
}
